<template>
  <b-container class="reserver">
    <h1 class="titre">Comment récupérer votre carte scolaire ?</h1>

    <div class="row bloc_comment_ca_marche">
      <div class="col-lg-4 col-md-12 etape">
        <i class="icone fas fa-phone-volume fa-5x"></i>
        <h2 class="titre_etape">1. Je prends rendez-vous</h2>
        <span class="texte_etape">
          Pour cela contactez-nous au<br/>
          <a class="lien" href="tel:0387390812">03 87 39 08 12</a>.
        </span>
      </div>
      <div class="col-lg-4 col-md-12 etape">
        <i class="icone fas fa-map-pin fa-5x"></i>
        <h2 class="titre_etape">2. Je récupère ma carte</h2>
        <span class="texte_etape">
          <ul>
            <li>Possibilité de récupérer la carte aux bureaux de 8h12h – 14hà17h – Château-Salins : 12 av Napoléon 1er </li>
            <li>Possibilité de récupérer la carte auprès du conducteur en ayant au préalable pris rendez-vous avec l’agence : 03 87 39 08 12</li>
          </ul>
        </span>
      </div>
      <div class="col-lg-4 col-md-12 etape">
        <i class="icone fas fa-money-bill fa-5x"></i>
        <h2 class="titre_etape">3. Règlement</h2>
        <span class="texte_etape">
          Le règlement pourra se faire sous enveloppe en espèces ou par chèque.
        </span>
      </div>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'RecupCarte'
  }
</script>

<style lang="scss">
@import "src/sass/app";

.reserver {
  .titre {
    text-align: center;
    font-weight: bold;
    font-family: $titlefont;
    font-size: 50px;
    color: $firstcolor;
    margin: 3rem 0;
  }

  .bloc_comment_ca_marche {
    text-align: center;
    background-color: $firstcolor;
    border-radius: 15px;
    color: white;
    margin-bottom: 2rem;
    @include media-breakpoint-up(sm) {
      padding: 3rem;
    }
    @include media-breakpoint-down(xs) {
      margin: 0 0.1rem 2rem 0.1rem;
    }

    .etape {
      margin: 2rem 0;

      @include media-breakpoint-up(sm) {
        padding: 0 2rem;
      }
      @include media-breakpoint-down(sm) {
        margin: 2.5rem 0;
      }

      .icone {
        margin-bottom: 2rem;
      }

      .titre_etape {
        text-transform: uppercase;
        font-family: $titlefont;
        font-size: 30px;
        font-weight: bold;
      }

      .texte_etape {
        font-family: $textfont;
        font-size: 18px;
        text-align: justify;
        .lien {
          color: white;
          font-weight: bold;
          text-transform: uppercase;
          text-decoration: underline;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/RecupCarte.vue